<payee-popup
  [onCancel]="cancel"
  [onSubmit]="submit"
>
  <ng-template #payeePopupTitleTemplate>
    <h1>Ügyvédi iroda létrehozása</h1>
  </ng-template>

  <payee-form-field width="wide">
    <span payee-label>Név</span>
    <input
      payee-input
      [formControl]="name"
    />
    @if (name.dirty && name.invalid) {
      <ng-container payee-error>
        @if (name.hasError("required")) {
          <span>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </span>
        }
        @if (name.hasError("maxlength")) {
          <span>
            {{ "ERROR_MESSAGES.MAXLENGTH" | translate }}
          </span>
        }
      </ng-container>
    }
  </payee-form-field>

  <app-address-form
    [form]="addressForm"
    [countries]="countries"
    [showToggle]="false"
  ></app-address-form>

  <payee-form-field width="wide">
    <span payee-label>Email</span>
    <input
      payee-input
      [formControl]="email"
    />
    @if (email.dirty && email.invalid) {
      <ng-container payee-error>
        @if (email.hasError("email")) {
          <span>
            {{ "ERROR_MESSAGES.INVALID_FORMAT" | translate }}
          </span>
        }
        @if (email.hasError("maxlength")) {
          <span>
            {{ "ERROR_MESSAGES.MAXLENGTH" | translate }}
          </span>
        }
      </ng-container>
    }
  </payee-form-field>

  <payee-form-field width="wide">
    <span payee-label>Telefonszám</span>
    <payee-phone [formControl]="phone"></payee-phone>
    @if (phone.dirty && phone.invalid) {
      <ng-container payee-error>
        @if (phone.hasError("maxlength")) {
          <span>
            {{ "ERROR_MESSAGES.MAXLENGTH" | translate }}
          </span>
        }
      </ng-container>
    }
  </payee-form-field>

  <span class="attorneys-label">Ügyvédek</span>
  <payee-form-field width="wide">
    <payee-autocomplete
      [formControl]="selectedAttorney"
      [displayWith]="attorneyDisplayWith"
      [options]="attorneyOptions"
      (searchChange)="searchAttorneys$.next($event)"
    ></payee-autocomplete>
  </payee-form-field>
  <div class="attorneys flex column">
    @for (attorney of attorneys.value; track attorney.id; let i = $index) {
      <div class="attorney-item flex vcenter">
        <span>{{ attorney.name }}</span>
        <button
          payee-mini-icon-button
          color="white"
          (click)="removeAttorney(i)"
        >
          <payee-icon name="trash-red"></payee-icon>
        </button>
      </div>
    }
  </div>
</payee-popup>
